module.exports = __webpack_public_path__ + "static/media/plaque_gtl_2023.f747ba7e.png";